import { ITemplateOptions, ITemplateScope } from "AngularFormly";
import { IQuery } from "../../server/query";
import { GridConfiguration } from "../../views/recordGridView";
import { vsComponentName } from "./names";

export interface SelectRecordModalConfig {
  gridConfiguration: GridConfiguration;
  defaultQuery?: IQuery;
  title: string;
  onItemSelected(
    item: any,
    modalInstance: angular.ui.bootstrap.IModalInstanceService
  ): void;
}

export class SelectRecordModalService {
  static $inject = ["$uibModal"];

  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  openModal(
    config?: SelectRecordModalConfig
  ): angular.ui.bootstrap.IModalInstanceService {
    return this.$uibModal.open({
      component: vsComponentName,
      resolve: {
        config: () => config,
      },
    });
  }

  getAddon(
    gridConfiguration: GridConfiguration,
    onSelect: (item: any, model: any, scope: ITemplateScope) => void
  ) {
    return {
      classAddon: "btn-secondary",
      class: "fa fa-plus-circle",
      onClick: (
        options: ITemplateOptions,
        model: any,
        scope: ITemplateScope
      ) => {
        this.openModal({
          title: "Email template",
          gridConfiguration,
          onItemSelected(item, modalInstance) {
            (<any>scope).selectedItem = item;
            onSelect(item, model, scope);
            modalInstance.close();
          },
        });
      },
    };
  }
}
